import React from "react";
import PropTypes from 'prop-types';
import TerminalsTable from "../components/Tables/TerminalsTable";
import { withStyles } from '@material-ui/core/styles';
import { connect } from "react-redux";
import CircularProgress from '@material-ui/core/CircularProgress';
import TerminalModal from '../components/Modals/TerminalModal';
import { loadTerminals } from '../actions/terminalActions';
import TableTop from '../components/Tables/TableSiteTop';
import { modalToggle } from '../actions/modalActions';
import { deleteTerminal } from '../actions/terminalActions';
import { clearDeleteTerminalsFailure } from '../actions/actionCreators';
import compose from 'recompose/compose';
import { showSnackbar } from "../actions/snackbarActions";
import { closeSnackbar } from "../actions/snackbarActions";
import  SnackbarMessage  from '../components/Layout/SnackbarMessage';
import { addTerminalsSearchCriteria } from '../actions/searchActions';

const styles = theme => ({
  root: {
    flexGrow: 1,
    padding: 8,
    margin: 8
  },
  progress: {
    margin: theme.spacing.unit * 2,
  }

});

class TerminalsPage extends React.Component {
  componentDidMount() {
    const { loadTerminals } = this.props;
    loadTerminals();
  }

  state = {
    isModalOpen: false,
    useEditModal: false,
    // When clicking a table row, the row is hilighted and modal opened.
    // This property is used for removing the hilight when modal is closed.
    useSelectedRow: true,
    selectedTerminal: null
  }

  handleModalOpen = () => {
    this.setState({ isModalOpen: true });
    this.props.modalToggle(true);
  };

  handleCreateModalClose = () => {
   // this.props.showSnackbar("test");
    this.setState({ isModalOpen: false, useEditModal: false, useSelectedRow: false, selectedTerminal: null });
    this.props.modalToggle(false);
  };

  handleRowClick = (terminal) => {
    if (this.props.isDeleting ) {
      return;
    }
    this.props.modalToggle(true);
    this.setState({isModalOpen: true, useEditModal: true, useSelectedRow: true, selectedTerminal: terminal});
  }

  handleTerminalDelete = async (terminal) => {
    if (this.props.isDeleting ) {
      return;
    }
    this.setState({ useSelectedRow: true, selectedTerminal: terminal});
    let ans = window.confirm("Are you sure you want to delete this terminal?");
    if(ans) {
      await this.props.deleteTerminal(terminal);
    }
    this.setState({ useSelectedRow: false, selectedTerminal: null});
  }

  handleSearchFieldChange = (searchCriteria) => {
    this.props.addTerminalsSearchCriteria(searchCriteria);
  }

  render() {
    const { classes, terminals, role } = this.props;
    const { isModalOpen,  useEditModal, useSelectedRow, selectedTerminal } = this.state;
    const { handleModalOpen, handleCreateModalClose } = this;
    const terminalCodes = terminals.terminalsData != null ? terminals.terminalsData.map(x => x.terminalCode) : [];

    return (
      <div className={classes.root}>
        <TableTop role={role} handleModalOpen={handleModalOpen} isButtonDisabled={(terminals.isLoading || terminals.hasErrored)} headlineText="Terminals"/>
        {terminals.hasErrored && (
        <p>Error</p>
      )}
      {(terminals.isLoading) && (
        <div>
          <CircularProgress className={classes.progress} size={50} />
        </div>
      )}
      {terminals.terminalsData != null && terminals.terminalsData.length > 0 && (
        <TerminalsTable
          role={role}
          handleTerminalDelete={this.handleTerminalDelete}
          useSelectedRow={useSelectedRow}
          handleRowClick={this.handleRowClick}
          terminals={terminals.terminalsData}
          handleSearchFieldChange={this.handleSearchFieldChange}
          searchFieldValues={this.props.searchFieldValues.terminals}
        />
      )}
      {role === "admin" && <TerminalModal  terminalCodes={terminalCodes} selectedTerminal={selectedTerminal} isEdit={useEditModal} isOpen={isModalOpen} handleClose={handleCreateModalClose}/>}
      <SnackbarMessage />
    </div>
    )
  }
}

TerminalsPage.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  return {
      terminals: state.terminal.terminals,
      isDeleting: state.terminal.terminals.isDeleting,
      deleteHasFailed: state.terminal.terminals.deleteHasFailed,
      searchFieldValues: state.searchField,
      role: (state.oidc.user && state.oidc.user.profile) ? state.oidc.user.profile.identity_role : null,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    loadTerminals: () => {
      dispatch(loadTerminals())
    },
    modalToggle: (value) => {
      dispatch(modalToggle(value));
    },
    deleteTerminal: (terminal) => {
      dispatch(deleteTerminal(terminal))
    },
    clearDeleteTerminalsFailure: () => {
      dispatch(clearDeleteTerminalsFailure())
    },
    showSnackbar: (msg) => {
        dispatch(showSnackbar(msg))
      },
    closeSnackbar: () => {
      dispatch(closeSnackbar())
    },
    addTerminalsSearchCriteria: (searchField) => {
      dispatch(addTerminalsSearchCriteria(searchField))
    }
  }
}

export default
  compose(
    withStyles(styles),
    connect(mapStateToProps, mapDispatchToProps)
  )(TerminalsPage);



// WEBPACK FOOTER //
// ./src/containers/TerminalsPage.js